module.exports = {
      id: "illustrations:NZ02-usage",
      viewBox: "0 0 476.2 330",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#illustrations:NZ02-usage",
      toString: function () {
        return this.url;
      }
    }